import { Fragment, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { Breadcrumbs } from "AbstractElements";
import TheForm from "Components/Common/Component/form/TheForm";
import { useCrudApi } from "hook/useCrudApi";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { useFormFields, parent, title } from "./constant";
import { LichSuThanhToan } from "models/lich-su-thanh-toan";

export const EditPage = () => {
  const { useUpdate, useGetById } = useCrudApi<LichSuThanhToan>("LichSuThanhToan");
  const { toList } = useResourceNavigate("lich-su-thanh-toan");

  const { id } = useParams();

  const { data, isFetched } = useGetById(id ?? "");

  const { formFields } = useFormFields();
  const useFormReturn = useForm();
  const { reset, handleSubmit } = useFormReturn;

  const { mutate } = useUpdate({
    onSuccess: (data) => {
      toast.success(`Cập nhật thành công`);
      toList();
    },
    onError: (error) => {
      toast.error(`Lỗi: ${error.message}`);
    },
  });

  const onSubmit = (values) => {
    mutate({ ...values, gioiTinh: Boolean(+values.gioiTinh) });
  };

  useEffect(() => {
    reset(data);
  }, [data, isFetched]);

  return (
    <Fragment>
      <Breadcrumbs title={title} parent={parent} mainTitle={title} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <TheForm
                  {...useFormReturn}
                  items={formFields}
                  onSubmit={handleSubmit(onSubmit)}
                  onCancel={toList}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
